var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Body } from '@lendi-ui/typography';
import { pb, pt } from '@lendi-ui/spacing';
import { deriveSize } from '@lendi-ui/utils';
export var DateDividerWrapper = styled(Body)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n  ", ";\n  ", ";\n  font-weight: 600;\n  font-size: ", ";\n"], ["\n  text-align: center;\n  ", ";\n  ", ";\n  font-weight: 600;\n  font-size: ", ";\n"])), pt('xs'), pb('xxs'), deriveSize(0.875));
var templateObject_1;
//# sourceMappingURL=style.js.map